<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    :color="showHome ? '#111820' : 'primary'"
    :prominent="showHome"
  >
    <router-link
      v-if="showHome"
      to="/home"
    >
      <v-img
        :src="require('@/assets/logo.png')"
        alt="logo"
        contain
        :max-width="logoWidth"
      />
    </router-link>

    <v-btn
      v-show="!showHome"
      class="mr-3"
      elevation="1"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>
      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      v-show="!showHome"
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />
    <div v-if="showHome">
      <v-btn
        color="white"
        icon
        large
        href="https://www.instagram.com/serhumanoeducacion/"
        target="_blank"
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>

      <v-btn
        color="white"
        icon
        large
        href="https://www.facebook.com/Ser-humano-Educaci%C3%B3n-para-el-siglo-XXI-101123351902222"
        target="_blank"
      >
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
    </div>

    <div v-if="viewPage">
      <notifications v-if="!showHome && user.type === 'tutor'" />
    </div>

    <v-menu
      bottom
      left
      offset-y
      transition="slide-x-transition"
      :rounded="true"
      :nudge-width="300"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          icon
          v-bind="attrs"
          large
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-if="user"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ user.nickname }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          @click="loginDialog = !loginDialog"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-right-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ingresar</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="user && showHome && viewPage"
          :to="toPanel(user.type)"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-right-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Panel</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="user"
          @click="signOut"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-left-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Salir</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <template v-if="showHome" v-slot:extension>
      <v-tabs
        v-if="showHome"
        v-model="model"
        right
        slider-color="transparent"
        color="basil"
      >
        <v-tab
          v-for="(item, i) in items"
          :key="i"
          :to="{ name: `${item.to}`}"
        >
          <span :class="`${item.color}--text`">{{ item.text }}</span>
        </v-tab>
      </v-tabs>
    </template>

    <login
      :login-dialog="loginDialog"
      @updateLoginDialog="updateLoginDialog"
    />
  </v-app-bar>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import login from '@/views/dashboard/pages/auth/Login'
  import Notifications from '@/views/dashboard/components/core/Notifications'

  export default {
    name: 'WebCoreAppBar',
    components: {
      login,
      Notifications,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      viewPage: false,
      messages: 1,
      loginDialog: false,
      model: 'tab-2',
      item: 1,
      items: [
        // { text: 'INICIO', icon: 'mdi-clock', color: 'four', to: 'Home' },
        { text: 'QUIÉNES SOMOS', icon: 'mdi-clock', color: 'four', to: 'About' },
        { text: 'ANIMALES AL RESCATE', icon: 'mdi-account', color: 'one', to: 'Rescue' },
        { text: 'CONTACTO', icon: 'mdi-flag', color: 'three', to: 'Contact' },
      ],
    }),

    computed: {
      ...mapState(['drawer', 'user', 'routesName']),
      showHome () {
        return this.routesName.includes(this.$route.name)
      },
      logoWidth () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '110'
          case 'sm': return '200'
          default: return '280'
        }
      },
    },
    watch: {
      user (val) {
        if (val) {
          this.viewPage = true
        } else {
          this.viewPage = false
        }
      },
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      toPanel (type) {
      console.log("toPanel: ", type);
        
        if (type === 'admin') {
          return '/admin/statistics'
        } else if (type === 'student') {
          return '/panel/student/0'
        } else {
          return '/panel/students'
        }
      },
      signOut () {
        this.$store.commit('SET_LOADING', true)
        this.$store.dispatch('SIGN_OUT')
      },
      updateLoginDialog (newData) {
        this.loginDialog = newData
      },
    },
  }
</script>

<style>
/* Helper classes */
.basil {
  background-color: #3f3f3f !important;
}
.basil--text {
  color: #356859 !important;
}
.one--text {
  color: #e0b824 !important;
}
.two--text {
  color: #21b1e2 !important;
}
.three--text {
  color: #d40054 !important;
}
.four--text{
  color: #66BB6A !important;
}
</style>
